import {
  Box,
  Button,
  Divider,
  Grid,
  HStack,
  Icon,
  Link,
  Popover,
  PopoverContent,
  PopoverTrigger,
  Stack,
  Tab,
  TabList,
  TabPanel,
  TabPanels,
  Tabs,
  Text,
  VStack,
  useDisclosure,
} from "@chakra-ui/react";
import { HiOutlineMenu, IoCloseSharp } from "../../customIcons";
import React, { FC } from "react";

import CategoriesTab from "../CategoriesTab";
import { GrayLogo } from "../../atoms/Logo";
import { useEffect } from "react";

type CustomPopoverType = {
  title?: string;
  items?: PopoverItemType[];
  baseUrl?: string;
  link?: string;
  bgColor?: string;
  withIcon?: boolean;
  hoverBg?: string;
  secondPanelItems?: any[];
};

type PopoverItemType = {
  name: string;
  slug: string;
  productTags: {
    nodes: string[];
  };
};

const CustomPopover: FC<CustomPopoverType> = ({
  title,
  link,
  bgColor,
  withIcon,
  hoverBg,
  secondPanelItems,
}) => {
  const { isOpen, onOpen, onClose } = useDisclosure();

  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "unset";
    }
  }, [isOpen]);
  return (
    <Popover
      id="nav-popover"
      trigger="click"
      openDelay={0}
      variant=""
      isOpen={isOpen}
      onOpen={onOpen}
      onClose={onClose}
      styleConfig={{ width: "100vw !important" }}
    >
      <PopoverTrigger>
        {link ? (
          <Link href={link}>
            <Button
              _hover={{ bg: hoverBg }}
              bg={bgColor}
              color="#fff"
              fontWeight="600"
            >
              {title}
            </Button>
          </Link>
        ) : (
          <Button
            _hover={{ bg: hoverBg }}
            bg={bgColor}
            color="#fff"
            fontWeight="600"
            leftIcon={withIcon ? <HiOutlineMenu color="#fff" /> : <></>}
          >
            {title}
          </Button>
        )}
      </PopoverTrigger>
      <PopoverContent
        mt="54px"
        h={"100vh"}
        minH={"100vh"}
        width="100%"
        bg="#F7FAFC"
        border="none"
        overflowY="auto"
      >
        <Box w={"100vw"} maxW={"100%"}>
          <HStack
            alignItems="flex-start"
            bg="#F7FAFC"
            w="100%"
            padding="0"
            margin="0"
          >
            <Tabs
              colorScheme="unset"
              isLazy
              w="100%"
              bg="#F7FAFC"
              variant="soft-rounded"
              id="1"
            >
              <HStack
                bg="#fff"
                h="84px"
                justifyContent="space-between"
                p="16px"
              >
                <HStack gap={0}>
                  <Icon
                    width="24px"
                    height="24px"
                    cursor="pointer"
                    mt="4px"
                    as={IoCloseSharp}
                    onClick={onClose}
                    mr={3}
                  />
                  <Divider
                    borderColor="#E2E8F0"
                    orientation="vertical"
                    h="52px"
                  />
                  <TabList ml={3}>
                    <Tab
                      fontSize="18px"
                      color="#1A202C"
                      fontWeight="600"
                      _selected={{ bg: "#3B2060", color: "#fff" }}
                      width="132px"
                      h="52px"
                    >
                      Categories
                    </Tab>
                    <Tab
                      fontSize="18px"
                      color="#1A202C"
                      _selected={{ bg: "#3B2060", color: "#fff" }}
                      width="132px"
                      h="52px"
                    >
                      Brands
                    </Tab>
                  </TabList>
                </HStack>

                <Stack>
                  <GrayLogo />
                </Stack>
              </HStack>

              <Divider w="100%" borderColor="#E2E8F0" />

              <TabPanels gap={0}>
                <TabPanel mb="80px">
                  <CategoriesTab />
                </TabPanel>

                <Stack gap={0} h="100%" w="100%">
                  <TabPanel mb="160px" w="100%" padding="20px" h="100%">
                    <Text fontSize="14px" color="#4A5568" pb="16px">
                      Brands
                    </Text>
                    <Grid
                      templateColumns={{
                        base: "repeat(1, 1fr)",
                        sm: "repeat(1, 1fr)",
                        md: "repeat(2, 1fr)",
                        lg: "repeat(3, 1fr)",
                        xl: "repeat(6, 1fr)",
                      }}
                      bg="#F7FAFC"
                      gap={6}
                    >
                      {secondPanelItems?.map((item: any, index: any) => {
                        return (
                          <VStack
                            maxW="235px"
                            key={index}
                            alignItems="flex-start"
                          >
                            <Text
                              fontSize="18px"
                              color="#3B2060"
                              fontWeight="700"
                              textAlign="start"
                              pl="4"
                            >
                              {item.startsWith}
                            </Text>

                            <VStack
                              borderTopWidth={1}
                              borderTopColor="#E2E8F0"
                              flex={1}
                              width="100%"
                              pt="6"
                              alignItems="flex-start"
                              pl="4"
                            >
                              {item.items.map((brand: any, index: any) => {
                                return (
                                  <Link
                                    key={index}
                                    href={`https://www.medsupplysolutions.com/${brand.slug}/`}
                                  >
                                    <Text
                                      _hover={{ textDecoration: "underline" }}
                                      fontSize="18px"
                                      textTransform={"uppercase"}
                                    >
                                      {brand.name}
                                    </Text>
                                  </Link>
                                );
                              })}
                            </VStack>
                          </VStack>
                        );
                      })}
                    </Grid>
                  </TabPanel>
                </Stack>
              </TabPanels>
            </Tabs>
          </HStack>
        </Box>
      </PopoverContent>
    </Popover>
  );
};

export default CustomPopover;
